exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white-stroke{stroke:#fff}.blue-stroke{stroke:#10284a}", ""]);

// exports
